import { DEFAULT_MAX_CHARACTER_EXCERPT, EXCERPT_SUFFIX } from '../constants';

export const getExcerpt = (
  content: string,
  max: number = DEFAULT_MAX_CHARACTER_EXCERPT,
  suffix: string = EXCERPT_SUFFIX
): string => {
  if (content.length < max) {
    return content;
  }

  const lastSpaceIndex = content
    .substring(0, max - suffix.length)
    .lastIndexOf(' ');

  return `${content.substring(0, lastSpaceIndex)}${suffix}`;
};
